import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    .partners-registration-container {
      min-width: 25rem;
      max-width: 40rem;
      margin-left: auto;
      margin-right: auto;
    }


    .partners-registration-container .registration-panel {
      padding: 4rem 3rem 4rem 3rem;
      text-align: center;
      border-radius: 3px;
      box-shadow: 0 .375em 1em rgba(0, 0, 0, .25);
      background: #ffffff;
    }

    .partners-registration-container .registration-panel img {
      width: 22rem;
      height: auto;
    }

    .partners-registration-container .registration-panel .panel-heading {
      background: #ffffff;
      padding-top: 2rem;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
    }

    .partners-registration-container .registration-panel .panel-heading h2 {
      margin: 0;
      font-weight: 700;
      line-height: 1.2;
      color: #5B6062;
    }
  `,
];
